<template>
    <div>
        <div class="select-container form-group col-12">
            <label for="size">{{ $t('Stand size of table') }}</label>
            <v-select :options="attributes.size.attribute_values" label="name" id="size" :clearable="false"
                v-model="product.attribute_values.size" />
        </div>
        <StandText v-if="standTextProductId.includes(product.id)" :label="$t('Text for engraving')" />
        <div class="form-group col-12 quantity">
            <label>{{ $t('Quantity') }}</label>
            <div class="qty">
                <span class="handler" @click="INCREMENT_QTY">+</span>
                <span class="counter">{{ product.qty }}</span>
                <span class="handler" @click="DECREMENT_QTY">-</span>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
import { standTextProductId } from "../../../../../config";
import VSelect from "vue-select";
import StandText from "./StandText"
import useProduct from "../../useProduct";

export default {
    components: {
        StandText,
        VSelect,
    },
    computed: {
        ...mapGetters({
            product: 'product/getProduct',
            attributes: 'product/getAttributes',
        })
    },
    watch: {
        'product.attribute_values.size'(newValue, oldValue) {
            this.calculateVariantPrice(this.product)
        }
    },
    methods: {
        ...mapMutations('product', [
            'INCREMENT_QTY',
            'DECREMENT_QTY'
        ]),
    },
    setup() {
        const {
            calculateVariantPrice
        } = useProduct()

        return {
            standTextProductId,
            calculateVariantPrice
        }
    }
}
</script>
<style scoped>
:deep() {
    --vs-dropdown-option--active-bg: #FF6601;
}
</style>